import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {isMobile} from '~/utils/screenSize';
import {useNavigate} from 'react-router-dom';
import {Link} from '@customink/pigment-react';
import {metrics} from '~/vendor/metrics';

const fireMetricEventFontWidthError = ({fontName, styleName}) => {
  if (!metrics || !fontName || !styleName) {
    return;
  }
  metrics.pageViewTag('/ndx/text/font/widtherror/');
  metrics.fireEvent('/ndx/text/font/widtherror/', [styleName, fontName]);
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function FontPixelWidthError({dismiss, ...props}) {
  const navigate = useNavigate();
  const {selectedStyle, notification} = props;
  const handleDismiss = () => {
    if (isMobile()) navigate(-1);
    dismiss();
  };

  useEffect(() => {
    fireMetricEventFontWidthError({
      fontName: notification?.fontName,
      styleName: selectedStyle?.name
    });
  }, [notification, selectedStyle]);

  return (
    <Notification {...props} title={<span>Font Width Size Error</span>}>
      <p>
        The font selected is too large for your text on this product. Please
        choose another font or reduce the number of characters.
      </p>
      <Link button variant="uiTextSmall" onClick={handleDismiss}>
        Choose a Different Font
      </Link>
    </Notification>
  );
}

const propTypes = {
  confirm: PropTypes.func,
  dismiss: PropTypes.func,
  notification: PropTypes.object,
  selectedStyle: PropTypes.object
};

FontPixelWidthError.propTypes = propTypes;

FontPixelWidthError.displayName = 'FontPixelWidthError';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';
import {getAnchorStyle} from '~/selectors/ProductSelectors';
import {confirm, dismiss} from '~/actions/NotificationActions';

function select(state) {
  return createStructuredSelector({
    selectedStyle: getAnchorStyle
  })(state);
}

function actions(dispatch) {
  return bindActionCreators(
    {
      confirm,
      dismiss
    },
    dispatch
  );
}

export default connect(select, actions)(FontPixelWidthError);
